import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../components/commonDesign/SydModal'
import DeleteDialogForm from './form'

const DeleteThreadDialog = React.forwardRef(function DeleteThreadDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (thread) => setDialogState({
      open: true,
      processing: false,
      thread
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Delete Thread'
      open={dialogState.open}
      onClose={close}
      size='small'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <DeleteDialogForm
            thread={dialogState.thread}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

DeleteThreadDialog.propTypes = {
  onComplete: PropTypes.func
}

DeleteThreadDialog.defaultProps = {
  onComplete: () => {}
}

export default DeleteThreadDialog
